import Vue from "vue";
import { mapGetters } from "vuex";

import { ErrorLogService, PartDetailServices } from "@/services";

import { LoadingSpinner, StaticFormControl } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";

import { default as SendError } from "../SendError.vue";
import { default as ThankYou } from "../ThankYou.vue";

import { IUserInfo } from "@/types";

export default Vue.extend({
    name: "EmailPartImages",
    mixins: [inputValidateState],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        StaticFormControl,
    },
    computed: {
        ...mapGetters(["tenantDetails", "user", "getContentItem", "activeAccountId"]),
    },
    props: {
        partId: {
            type: Number,
            default: 0
        },
        oemPartCode: {
            type: String,
            default: "",
        },
        closeForm: {
            type: Function,
            required: true,
        },
    },

    data: () => ({
        showThankYou: false,
        showSendError: false,
        isBusy: false,
        errorMessage: "",
        formIsValid: {},

        // form fields
        to: "",
        message: "",
    }),

    created() {
      this.to = this.user.Email;
    },

    updated() {
        this.$validator.validateAll().then((result: any) => {
            this.formIsValid = result;
        });
    },

    methods: {
        async submitForm() {
            try {
                this.showThankYou = false;
                this.isBusy = true;

                const { UserId, Email, FullName, FirstName, LastName } = this.user as IUserInfo;

                await PartDetailServices.emailPartImages({
                    AccountId: this.activeAccountId,
                    UserId,
                    Email,
                    FullName,
                    PartId: this.partId,
                    FirstName,
                    LastName,                  
                    OemPartCode: this.oemPartCode,
                    ToAddress: this.to,
                    Message: this.message,
                });

                this.showThankYou = true;
            } catch (err) {
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isBusy = false;
            }
        },
    },
});
